import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";

export const getGDSearchlist = (searchItem) => {
  let url = `${API.GDSearch}?companyname=${searchItem.companyname}&PageNumber=${searchItem.pagenumber}&PageSize=${searchItem.pagesize}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "GetGDSearchSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "GetGDSearchFailure",
          error: "ERROR"
        })
      })
  }
}
export const deleteGD = (id) => {
  let url = `${API.GDDelete}${id}`;
  return dispatch => {
    axios.delete(url)
      .then((response) => {
        toast.success('Deleted Successfully', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        dispatch({
          type: "GDDeleteSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "GDDeleteFailure",
          error: "ERROR"
        })
      })
  }
}